<template lang="pug">
#sub-empresa-bloco-dados-contrato-originacao
    h2.mb-3.mt-3 Dados do contrato de originação

    BlocoSkeletonDadosGerais(:carregando='carregandoDadosGerais')
        el-card(shadow='never', :body-style='{ padding: "16px" }')
            .bloco-dados-contrato-originacao__linha
                .bloco-dados-contrato-originacao-informacao
                    h4 Nº contrato
                    p {{ dados.numeroContrato }}

                .bloco-dados-contrato-originacao-informacao
                    .bloco-dados-contrato-originacao-codigo-externo
                        h4 Nº contrato cliente
                        el-tooltip(v-if='dados.codigoExterno', placement='top')
                            .codigo-externo--tooltip(slot='content') {{ tooltipCopiarCodigo }}
                            i.mdi.mdi-content-copy(
                                @click='copiarCodigoParaAreaTransferencia(dados.codigoExterno)'
                            )
                        i.el-icon-edit(
                            @click='atualizarModalCodigoExterno(true)'
                        )
                    p.codigo-externo--minificado {{ dados.codigoExterno ? dados.codigoExterno : '--' }}

                .bloco-dados-contrato-originacao-informacao
                    h4 Cliente
                    p {{ dados.nomeCliente }}

                .bloco-dados-contrato-originacao-informacao
                    h4 Cultura
                    p {{ dados.materialNome }}

                .bloco-dados-contrato-originacao-informacao
                    h4 Safra
                    p {{ dados.safraNome }}

                .bloco-dados-contrato-originacao-informacao
                    h4 Data do contrato
                    p {{ dados.dataContrato }}

            .bloco-dados-contrato-originacao__linha
                .bloco-dados-contrato-originacao-informacao
                    h4 Estado
                    p {{ dados.estadoSigla }}

                .bloco-dados-contrato-originacao-informacao
                    h4 Município
                    p {{ dados.municipioNome }}

                .bloco-dados-contrato-originacao-informacao
                    h4 Volume vendido (t)
                    p {{ dados.volumeContratado }}

                .bloco-dados-contrato-originacao-informacao
                    .informacao-volumes-contrato
                        .volumes
                            h4 Volume adicionado (t)
                            p {{ dados.volumeAdicionado }}
                        el-tooltip(
                            content='Somatório dos volumes  adicionados no contrato, sejam eles conformes ou inconformes.',
                            placement='top'
                        )
                            i.el-icon-info.volumes-contrato

                .bloco-dados-contrato-originacao-informacao
                    .informacao-volumes-contrato
                        .volumes
                            h4 Volume restante (t)
                            p {{ dados.saldoRestante }}
                        el-tooltip(
                            content='Volume disponível para ser inserido no contrato.',
                            placement='top'
                        )
                            i.el-icon-info.volumes-contrato

    div(v-if='modalCodigoExternoVisivel')
        BlocoInserirCodigoExterno(
            :dados='dados',
            :dialogVisible='modalCodigoExternoVisivel',
            @fechar='atualizarModalCodigoExterno',
            @verificarConcluir='verificarConcluir'
        )
</template>

<script>
import BlocoInserirCodigoExterno from '@/components/contratosOriginacao/SubEmpresaBlocoInserirCodigoExterno.vue';
import BlocoSkeletonDadosGerais from '@/components/contratosOriginacao/BlocoSkeletonDadosGerais.vue';
export default {
    name: 'SubEmpresaBlocoDadosContratoOriginacaoAlvorada',

    emits: ['verificarConcluir'],

    components: {
        BlocoInserirCodigoExterno,
        BlocoSkeletonDadosGerais
    },

    props: {
        dados: {
            required: true,
            type: Object
        },
        carregandoDadosGerais: {
            required: true,
            type: Boolean
        }
    },

    data() {
        return {
            modalCodigoExternoVisivel: false,
            tooltipCopiarCodigo: 'Copie o código'
        };
    },

    methods: {
        copiarCodigoParaAreaTransferencia() {
            this.tooltipCopiarCodigo = 'Copiado';
            navigator.clipboard
                .writeText(this.dados.codigoExterno)
                .then(() => {
                    setTimeout(() => {
                        this.tooltipCopiarCodigo = 'Copie o código';
                    }, 1000);
                })
                .catch(function (error) {
                    // eslint-disable-next-line no-console
                    console.error('Erro ao copiar o texto: ', error);
                });
        },

        atualizarModalCodigoExterno(value) {
            this.modalCodigoExternoVisivel = value;
        },

        verificarConcluir() {
            this.$emit('verificarConcluir', true);
        }
    }
};
</script>

<style lang="scss" scoped>
#sub-empresa-bloco-dados-contrato-originacao {
    .mb-3 {
        font-weight: bold;
        margin-bottom: 20px;
    }
    .bloco-dados-contrato-originacao__linha {
        display: grid;
        grid-template-columns: repeat(6, 1fr);

        h4 {
            font-weight: bold;
            color: var(--primary);
        }
    }

    .bloco-dados-contrato-originacao__linha:last-of-type p {
        margin: 0;
    }

    .bloco-dados-contrato-originacao-codigo-externo {
        display: flex;
        align-items: center;
        gap: 5px;

        i {
            cursor: pointer;
        }

        i:hover {
            color: var(--primary);
            font-weight: bold;
        }
    }

    .bloco-dados-contrato-originacao-informacao {
        flex: 1;

        .informacao-volumes-contrato {
            display: flex;
            gap: 2px;
        }
        .codigo-externo--minificado {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        p {
            word-break: break-all;
        }
    }
    .el-card.codigo-externo.is-never-shadow {
        margin-top: 4px;
    }
}
.codigo-externo--tooltip {
    width: 90px;
    text-align: center;
}

i.el-icon-info.volumes-contrato {
    color: var(--secondary-font-color);
}
</style>
